import { createSelector } from 'reselect'
import { schema, normalize } from 'normalizr'

const normalizeGroups = data => {
  const group = new schema.Entity('groups')
  return normalize(data, [group])
}

const getGroups = groups => groups

const getNormalizedGroups = createSelector(
  [getGroups],
  groups => normalizeGroups(groups)
)

const getGroupsMap = createSelector(
  [getNormalizedGroups],
  normalizedGroups => normalizedGroups.entities.groups
)

const getGroup = (groups, id) => getGroupsMap(groups)[id]

const getFilteredGroups = (groups, selectedCategory) =>
  selectedCategory === 'ALL'
    ? groups
    : groups.filter(group => group.category === selectedCategory)

export { getGroup, getFilteredGroups }
